import React from "react";
import "./VideoGallery.css";

const videos = [
  {
    id: 1,
    // title: "Laser Show",
    src: "./images/gallery/video-1.mp4",
    poster: "./images/gallery/p-1.png"
  },
 
];

const VideoGallery = () => {
  return (
    <div className="video-wrapper">
      {videos.map((video) => (
        <div className="video-card" key={video.id}>
          <video
            controls
            preload="metadata"
            poster={video.poster}
          >
            <source src={video.src} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          <h4>{video.title}</h4>
        </div>
      ))}
    </div>
  );
};

export default VideoGallery;
